import { MessageBox, Loading } from 'element-ui';
import router from "../router/router"
import { MS } from "../services/ManageService.service";
const state = {
    data_table: [],
    proportion_main_promotion: 0,
    proportion_ontop_promotion: 0,
    id: 0
};
const actions = {
    async list({ commit }, data) {
        state.data_table = []
        let result = await MS.list();
        if (result.status === 200) {
            commit('PUT_DATA', result.data[0])
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async listMobile({ commit }, data) {
        state.data_table = []
        let result = await MS.listMobile();
        if (result.status === 200) {
            commit('PUT_DATA', result.data[0])
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async updateMobile({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await MS.updateMobile({ id: data.id, proportion_minute: data.proportion_minute, proportion_second: data.proportion_second });
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_mobile_service' })
            }).catch(() => {
                router.push({ name: 'Manage_mobile_service' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async update({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await MS.update({ id: data.id, proportion_main: data.proportion_main, proportion_ontop: data.proportion_ontop });
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_service' })
            }).catch(() => {
                router.push({ name: 'Manage_service' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    }
};

const mutations = {
    PUT_DATA(state, data) {
        state.data_table.push(data)
    }
};

export const ManageService = {
    namespaced: true,
    state,
    actions,
    mutations
};